/* import __COLOCATED_TEMPLATE__ from './focus-manager.hbs'; */
import Component from '@ember/component';
import { guidFor } from '@ember/object/internals';
import { inject as service } from '@ember/service';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: '',
  focus: service(),
  init(...args) {
    this._super(...args);
    this.set('focusId', guidFor(this));
  },
  didInsertElement(...args) {
    this._super(...args);
    this.get('focus').addFocusManager(this.get('focusId'), this.get('autofocusSelector'));
  },
  willDestroyElement(...args) {
    this.get('focus').removeFocusManager(this.get('focusId'));
    this._super(...args);
  },
  actions: {
    captureFocus(which) {
      this.get('focus').captureFocus(this.get('focusId'), which);
    }
  }
});